// extracted by mini-css-extract-plugin
module.exports = {"callout":"CreateInviteCallout_callout__FdrOk"};